/**
 * Probe de conectividade. `navigator.onLine` mente em iOS Safari (true mesmo sem rota
 * para o backend específico), então fazemos uma HEAD curta no `/health` com timeout 3s.
 *
 * Usado pelo foreground sync para evitar disparar pushes que vão falhar imediatamente.
 *
 * Mesma resolução de API_BASE do fetchClient — em native usa URL absoluta da Pages
 * pra manter a Pages Function no caminho (CORS único, mesma policy).
 */
import { isNative } from '@/core/platform/runtime'

const PROD_BASE = 'https://infrawork.pages.dev/api'

const API_BASE = import.meta.env.VITE_API_BASE_URL
  ?? (isNative() ? PROD_BASE : '/api')

export async function isBackendReachable(): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return false

  const ctrl = new AbortController()
  const timer = setTimeout(() => ctrl.abort(), 3000)
  try {
    const res = await fetch(`${API_BASE}/health`, {
      method: 'HEAD',
      signal: ctrl.signal,
      cache: 'no-store',
    })
    return res.ok
  } catch {
    return false
  } finally {
    clearTimeout(timer)
  }
}
